// 1. The Configuration Object (Matrix Architecture)
const upsellConfig = {
  "30-day-facial-ritual": {
    steps: [
      {
        stepId: "mask_choice",
        header: "Personalize your ritual",
        subHeader: "Step 1 of 2 &middot; takes 10 seconds",
        question: "Do you have sensitive skin?",
        subQuestion: "Help us select the right mask",
        options: [
          { value: "mask_sensitive", label: "Yes", desc: "Lavender and chamomile mask" },
          { value: "mask_normal", label: "No", desc: "Pomegranate and frankincense mask" }
        ],
        skipText: "Skip, use default mask",
        skipValue: "mask_normal"
      },
      {
        stepId: "serum_choice",
        header: "Personalize your ritual",
        subHeader: "Step 2 of 2 &middot; takes 10 seconds",
        question: "Want to see an even bigger difference?",
        subQuestion: "Upgrade to our high performance Face Serum",
        options: [
          { value: "serum_yes", label: "Yes", desc: "Upgrade to Face Serum for €40 more" },
          { value: "serum_no", label: "No", desc: "I'm happy with the Award Winning Face Oil" }
        ],
        skipText: "Skip, no upgrade",
        skipValue: "serum_no"
      }
    ],
    matrix: {
      "mask_sensitive|serum_yes": 58322933940549, 
      "mask_sensitive|serum_no":  58322933875013, 
      "mask_normal|serum_yes":    58322933907781, 
      "mask_normal|serum_no":     58322933842245  
    }
  },
  "90-day-facial-ritual": {
    steps: [
      {
        stepId: "mask_choice",
        header: "Personalize your ritual",
        subHeader: "Step 1 of 2 &middot; takes 10 seconds",
        question: "Do you have sensitive skin?",
        subQuestion: "Help us select the right mask",
        options: [
          { value: "mask_sensitive", label: "Yes", desc: "Lavender and chamomile mask" },
          { value: "mask_normal", label: "No", desc: "Pomegranate and frankincense mask" }
        ],
        skipText: "Skip, use default mask",
        skipValue: "mask_normal"
      },
      {
        stepId: "serum_choice",
        header: "Personalize your ritual",
        subHeader: "Step 2 of 2 &middot; takes 10 seconds",
        question: "Want to see an even bigger difference?",
        subQuestion: "Upgrade to our high performance Face Serum",
        options: [
          { value: "serum_yes", label: "Yes", desc: "Upgrade to Face Serum for €40 more" },
          { value: "serum_no", label: "No", desc: "I'm happy with the Award Winning Face Oil" }
        ],
        skipText: "Skip, no upgrade",
        skipValue: "serum_no"
      }
    ],
    matrix: {
      "mask_sensitive|serum_yes": 58430848139589, 
      "mask_sensitive|serum_no":  58430848106821, 
      "mask_normal|serum_yes":    58430848074053, 
      "mask_normal|serum_no":     58430848041285  
    }
  }
};

// 2. The Interceptor & State Manager
document.addEventListener('DOMContentLoaded', function() {
  const addToCartBtn = document.querySelector('.product-form__cart-submit.btn--full');
  if (!addToCartBtn) return;

  const currentProductHandle = window.location.pathname.split('/').pop(); 
  const currentConfig = upsellConfig[currentProductHandle];

  if (!currentConfig) return;

  addToCartBtn.addEventListener('click', function(e) {
    e.preventDefault(); 
    
    const baseForm = addToCartBtn.closest('form');
    const baseFormData = new FormData(baseForm);
    const baseQuantity = parseInt(baseFormData.get('quantity') || 1);

    let userChoices = [];
    
    const sourceDiv = document.querySelector('.exit-source');
    if (!sourceDiv) return console.error('Missing .exit-source container in DOM.');

    sourceDiv.innerHTML = ''; 
    let dynamicModal = new ElKitModal({
      sourceSelector: '.exit-source',
      config: { closingKeys: ["Escape"], maxWidth: "600px", scrollableBody: true }
    });
    
    dynamicModal.open();

    const liveModalContainer = document.querySelector('.el-modal-content');
    renderStep(0, currentConfig, liveModalContainer, baseQuantity, userChoices, dynamicModal);
  });
});

// 3. Centralized Cart Submission API
function executeCartAdd(matrixKey, configObj, baseQty, modalInstance, triggerBtn, errorContainer) {
  const finalVariantId = configObj.matrix[matrixKey];

  if (!finalVariantId) {
    errorContainer.innerText = "Configuration Error: No variant mapped for this combination.";
    triggerBtn.disabled = false;
    triggerBtn.innerText = triggerBtn.dataset.originalText;
    return;
  }

  const finalPayload = [{ id: parseInt(finalVariantId), quantity: baseQty }];
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: finalPayload })
  })
  .then(async response => {
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || errorData.message || 'Failed to add items to cart.');
    }
    return response.json();
  })
  .then(() => {
    modalInstance.close();
    if (typeof quickCartObject !== 'undefined') {
      quickCartObject.refreshQuickCart();
      quickCartObject.openQuickCart();
    } else {
      window.location.href = '/cart'; 
    }
  })
  .catch(error => {
    console.error('Cart Error:', error.message);
    errorContainer.innerText = error.message; 
    triggerBtn.disabled = false;
    triggerBtn.innerText = triggerBtn.dataset.originalText;
  });
}

// 4. The Matrix Renderer (Auto-Advance & State Optimized)
function renderStep(stepIndex, configObj, container, baseQty, userChoices, modalInstance) {
  const stepData = configObj.steps[stepIndex];
  const isLastStep = stepIndex === configObj.steps.length - 1;
  const isFirstStep = stepIndex === 0;
  const radioGroupName = `upsell_step_${stepIndex}`;
  let isProcessing = false;

  // Render segmented flex track
  const progressHtml = configObj.steps.map((_, index) => {
    return `<div class="ritual-progress-segment ${index <= stepIndex ? 'is-active' : ''}"></div>`;
  }).join('');

  const optionsHtml = stepData.options.map((opt, index) => {
    const uniqueId = `upsell_radio_${stepIndex}_${index}`;
    const isChecked = userChoices[stepIndex] === opt.value ? 'checked' : '';
    const activeClass = isChecked ? 'is-selected' : '';
    
    return `
      <div class="ritual-option">
        <input type="radio" id="${uniqueId}" class="ritual-radio-hidden" name="${radioGroupName}" value="${opt.value}" ${isChecked}>
        <label for="${uniqueId}" class="option-box dynamic-label ${activeClass}">
          <span class="option-title">${opt.label}</span>
          <span class="option-desc">${opt.desc}</span>
        </label>
      </div>
    `;
  }).join('');

  container.innerHTML = `
    <div class="ritual-modal-header">
      <div class="ritual-progress-track">
        ${progressHtml}
      </div>
      <h2>${stepData.header}</h2>
      <p>${stepData.subHeader}</p>
    </div>
    <div class="ritual-modal-body">
      <h3>${stepData.question}</h3>
      <p class="subtitle">${stepData.subQuestion}</p>
      ${optionsHtml}
    </div>
    <div class="ritual-modal-footer">
      <div class="select-prompt-msg" style="display: ${userChoices[stepIndex] ? 'none' : 'block'};">Select an option to continue</div>
      <div class="ritual-actions">
        ${!isLastStep 
          ? `<button type="button" class="skip-step-btn">${stepData.skipText}</button>` 
          : `<div class="nav-buttons-wrapper">
               <button type="button" id="dynamic-back-btn" class="btn btn--medium">Back</button>
               <button type="button" id="dynamic-next-btn" class="btn btn--medium btn--secondary" ${!userChoices[stepIndex] ? 'disabled' : ''}>Confirm & Add to Cart</button>
             </div>
             `
        }
      </div>
      <div class="ritual-error-msg" style="color: red; margin-top: 10px; font-size: 14px;"></div>
    </div>
  `;

  const errorContainer = container.querySelector('.ritual-error-msg');

  // Handle Radio Selections
  const radios = container.querySelectorAll(`input[name="${radioGroupName}"]`);
  radios.forEach(radio => {
    radio.addEventListener('change', function(e) {
      if (isProcessing) return; 

      container.querySelectorAll('.dynamic-label').forEach(lbl => {
        lbl.classList.remove('is-selected');
      });
      const checkedLabel = container.querySelector(`label[for="${e.target.id}"]`);
      if (checkedLabel) {
        checkedLabel.classList.add('is-selected');
      }

      userChoices[stepIndex] = e.target.value;

      if (!isLastStep) {
        isProcessing = true; 
        setTimeout(() => {
          renderStep(stepIndex + 1, configObj, container, baseQty, userChoices, modalInstance);
        }, 300);
      } else {
        const nextBtn = document.getElementById('dynamic-next-btn');
        if (nextBtn) nextBtn.disabled = false;
        
        // Nukes the prompt text once they make a selection
        const promptMsg = container.querySelector('.select-prompt-msg');
        if (promptMsg) promptMsg.style.display = 'none';
      }
    });
  });

  // Handle Skip Button (Instant Bypass)
  if (!isLastStep) {
    const skipBtn = container.querySelector('.skip-step-btn');
    if (skipBtn) {
      skipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        this.dataset.originalText = this.innerText;
        this.innerText = 'Processing...';
        this.disabled = true;

        // Map every step's default value automatically to generate matrix key
        const defaultMatrixKey = configObj.steps.map(step => step.skipValue).join('|');
        
        executeCartAdd(defaultMatrixKey, configObj, baseQty, modalInstance, this, errorContainer);
      });
    }
  }

  // Handle Back Button
  if (!isFirstStep) {
    const backBtn = document.getElementById('dynamic-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        renderStep(stepIndex - 1, configObj, container, baseQty, userChoices, modalInstance);
      });
    }
  }

  // Handle Final Submission
  if (isLastStep) {
    const nextBtn = document.getElementById('dynamic-next-btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation(); 
        if (nextBtn.disabled) return; 
        
        this.dataset.originalText = this.innerText;
        this.innerText = 'Processing...';
        this.disabled = true;
        
        const matrixKey = userChoices.join('|');
        executeCartAdd(matrixKey, configObj, baseQty, modalInstance, this, errorContainer);
      });
    }
  }
}